export const emptyProducts = [] as const
export const skeletonProducts = [null, null, null, null] as const

export enum ItemType {
    Skeleton = 'skeleton',
    Header = 'header',
    Product = 'product',
    Container = 'container',
}

export const containersCategoryId = 'containers'

export const headerHeight = 16
export const productCellHeight = 120
export const productRowHeight = 95
export const separatorHeight = 8
export const productApproximateWidth = 180
export const productSpacing = 8

export const columnModeNumColumns = 2 // 2 columns must be used to force constant items height
